import { render } from "./IconFile.vue?vue&type=template&id=1374c92b"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1374c92b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1374c92b', __exports__)) {
    api.reload('1374c92b', __exports__)
  }
  
  module.hot.accept("./IconFile.vue?vue&type=template&id=1374c92b", () => {
    api.rerender('1374c92b', render)
  })

}


export default __exports__